(function () {
  function formatCLP(amount) {
    return '$' + Math.round(amount).toLocaleString('es-CL');
  }

  function parseCLP(text) {
    if (!text) return 0;
    const digits = text.replace(/[^0-9]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function generateBundleId() {
    if (window.crypto && window.crypto.randomUUID) return 'cbid_' + window.crypto.randomUUID();
    return 'cbid_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function getBundleContainer(el) {
    return el.closest('[data-cozy-upsell-bundle]');
  }

  function updateBundleDisplay(container) {
    const qty = parseInt(container.querySelector('[data-cozy-qty-value]').textContent, 10) || 1;
    const price1 = parseCLP(container.dataset.price1);
    const price2 = parseCLP(container.dataset.price2);
    const price3 = parseCLP(container.dataset.price3);

    let total = price1;
    if (qty === 2 && price2) total = price2;
    if (qty === 3 && price3) total = price3;
    if (qty > 3) total = (price3 || price1 * 3) + (price1 * (qty - 3));

    const totalEl = container.querySelector('[data-cozy-total]');
    const unitEl = container.querySelector('[data-cozy-unit]');
    const badgeEl = container.querySelector('[data-cozy-badge]');

    if (totalEl) totalEl.textContent = formatCLP(total);
    if (unitEl) unitEl.textContent = qty > 1 ? formatCLP(total / qty) + ' c/u' : '';
    if (badgeEl) badgeEl.hidden = qty < 2;

    container.dataset.currentQty = qty;
    container.dataset.currentTotal = total;
  }

  function findVariant(variants, selects) {
    const values = Array.from(selects).map((s) => s.value);
    return (
      variants.find((v) => {
        const vals = [v.option1, v.option2, v.option3].filter((x) => x !== null && x !== undefined);
        return vals.length === values.length && vals.every((val, i) => val === values[i]);
      }) || null
    );
  }

  async function refreshCartUI() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      try {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
      } catch (e) {
        /* ignore */
      }
    }
    try {
      const response = await fetch('/?sections=cart-drawer,header');
      if (!response.ok) return;
      const sections = await response.json();
      const parser = new DOMParser();
      if (sections['cart-drawer']) {
        const current = document.querySelector('cart-drawer');
        const fresh = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
        if (current && fresh) current.replaceWith(fresh);
      }
      if (sections['header']) {
        const current = document.querySelector('#cart-icon-bubble');
        const fresh = parser.parseFromString(sections['header'], 'text/html').querySelector('#cart-icon-bubble');
        if (current && fresh) current.replaceWith(fresh);
      }
    } catch (e) {
      /* ignore — the add itself already succeeded */
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  document.addEventListener('click', (evt) => {
    const minusBtn = evt.target.closest('[data-cozy-qty-minus]');
    const plusBtn = evt.target.closest('[data-cozy-qty-plus]');
    const addBtn = evt.target.closest('[data-cozy-bundle-add]');

    if (minusBtn || plusBtn) {
      const container = getBundleContainer(minusBtn || plusBtn);
      if (!container) return;
      const valueEl = container.querySelector('[data-cozy-qty-value]');
      let qty = parseInt(valueEl.textContent, 10) || 1;
      qty = minusBtn ? Math.max(1, qty - 1) : Math.min(10, qty + 1);
      valueEl.textContent = qty;
      updateBundleDisplay(container);
      return;
    }

    if (addBtn) {
      evt.preventDefault();
      if (addBtn.disabled || addBtn.dataset.loading === 'true') return;

      const scope = addBtn.closest('.upsell') || document;
      const container = scope.querySelector('[data-cozy-upsell-bundle]');
      const variantsScript = scope.querySelector('[data-cozy-bundle-variants]');
      const selects = scope.querySelectorAll('.upsell__select select');
      if (!container || !variantsScript) return;

      const qty = parseInt(container.querySelector('[data-cozy-qty-value]').textContent, 10) || 1;
      const variants = JSON.parse(variantsScript.textContent);
      const variant = selects.length ? findVariant(variants, selects) : variants[0];

      if (!variant || !variant.available) {
        const label = addBtn.querySelector('[data-cozy-add-label]');
        if (label) label.textContent = 'No disponible en esa combinación';
        return;
      }

      const item = { id: variant.id, quantity: qty, properties: {} };
      if (qty > 1) {
        const bundleId = generateBundleId();
        const unitNumbers = [];
        for (let i = 1; i <= qty; i++) unitNumbers.push(i);
        item.properties = {
          _bundle_id: bundleId,
          _bundle_name: 'Pack de ' + qty + ' chalequitos',
          _bundle_size: String(qty),
          _bundle_unit_number: unitNumbers.join(','),
        };
      }

      addBtn.dataset.loading = 'true';
      addBtn.disabled = true;
      const spinner = addBtn.querySelector('[data-cozy-add-spinner]');
      if (spinner) spinner.classList.remove('hidden');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || data.message || 'No se pudo agregar al carrito.');
          return refreshCartUI();
        })
        .catch(() => {
          const label = addBtn.querySelector('[data-cozy-add-label]');
          if (label) label.textContent = 'Ocurrió un error, intenta de nuevo';
        })
        .finally(() => {
          addBtn.dataset.loading = 'false';
          addBtn.disabled = false;
          if (spinner) spinner.classList.add('hidden');
        });
    }
  });

  document.addEventListener('change', (evt) => {
    if (evt.target.matches('.upsell__select select')) {
      const container = getBundleContainer(evt.target.closest('.upsell'));
      if (container) updateBundleDisplay(container);
    }
  });

  document.querySelectorAll('[data-cozy-upsell-bundle]').forEach(updateBundleDisplay);
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-cozy-upsell-bundle]').forEach(updateBundleDisplay);
  });
})();
